import './outtra-integration.scss';

class OuttraIntegration {
    constructor (scriptCount, $context) {
        this.$$outtraIntegrationButtons = null;
        this.scriptCount = scriptCount;
        this.$content = $context;
        this.$$outtraItems = null;
        this.resetIntervallFallback = 0;
    }

    initialize () {
        const waitForButtons = setInterval(() => {
            this.$$outtraIntegrationButtons = this.$content.querySelectorAll('.outtra-modal-trigger-button:not(.is--empty)');

            if (this.$$outtraIntegrationButtons.length === this.scriptCount) {
                clearInterval(waitForButtons);
                this.setButtons();
            }
            // timeout for interval to prevent from running an infinite loop
            this.resetIntervallFallback += 1;
            if (this.resetIntervallFallback === 500) {
                clearInterval(waitForButtons);
                this.setButtons();
            }
        }, 10);
    }

    clearPlaceholders () {
        if (this.$content instanceof Document) {
            this.$$outtraItems = this.$content.querySelectorAll('[data-outtra-item="slide"]');
        } else {
            this.$$outtraItems = this.$content;
        }

        if (this.$$outtraItems !== null) {
            if (this.$$outtraItems.length >= 1) {
                this.$$outtraItems.forEach($outtraItem => {
                    const $outtraPlaceholder = $outtraItem.querySelector('[data-outtra-placeholer]');
                    const $outtraButton = $outtraItem.querySelector('.outtra-modal-trigger-button:not(.is--empty)');
                    if ($outtraButton) {
                        $outtraPlaceholder.remove();
                    }
                });
            } else {
                const $outtraPlaceholder = this.$$outtraItems.querySelector('[data-outtra-placeholer]');
                const $outtraButton = this.$$outtraItems.querySelector('.outtra-modal-trigger-button:not(.is--empty)');
                if ($outtraButton) {
                    $outtraPlaceholder.remove();
                }
            }
        }
    }

    setButtons () {
        this.$$outtraIntegrationButtons.forEach((button) => {
            button.classList.add('cta');
            button.classList.add('is--secondary');
            button.classList.add('icon-basket');
            button.innerText = buy_local_translation; // eslint-disable-line
        });

        this.clearPlaceholders();
    }
}

export { OuttraIntegration };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$outtraIntegrations = $context.querySelectorAll('[data-gtins]');

        if ($$outtraIntegrations.length > 0) {
            const $outtra = new OuttraIntegration($$outtraIntegrations.length, $context);
            $outtra.initialize();
        }
    }
});
